// import dJSON from 'dirty-json';
// import '../node_modules/@lottiefiles/lottie-player/dist/lottie-player';

import './js/base/base-start';
import './js/global';

// modules - core
import './modules/core/accordion/module';

// modules
import './modules/evox/top-bar/module';
import './modules/theme/category-boxes/module';
import './modules/theme/information-section/module';
import './modules/evox/resources-articles-blog/module';
import './modules/theme/services/module';
import './modules/theme/industries/module';
import './modules/evox/signup-blog-slider/module';
import './modules/theme/accreds/module';
// import './modules/evox/megamenu/module';
import './modules/evox/shop-all/module';
import './modules/evox/account-slidein/module';
import './modules/evox/branch-finder/module';
import './modules/evox/carousels/module';
import './modules/evox/pdp-popup/module';
import './modules/theme/info-accordion/module';
import './modules/theme/small-banner/module';
import './modules/theme/custom-content/module';
import './modules/theme/tabbed-gallery/module';
import './modules/theme/content-cards/module';
import './modules/theme/timeline/module';
import './modules/theme/image-carousel/module';

// layouts
import './layouts/plp/layout';
import './layouts/pdp/layout';
import './layouts/basket/layout';
import './layouts/industries/layout';

// leave me last
import './js/base/base-end';
